<template>
  <div id="app">
    <div v-show="!isLoading">
      <div v-if="isFullscreen">
        <router-view/>
      </div>

      <div v-else>
        <PublicHeader/>
<!--        <PublicCarousel/>-->
        <router-view/>
        <PublicFooter/>
      </div>
    </div>

    <!-- 加载指示器，防止内容区域闪烁 -->
    <div
        v-if="isLoading"
        class="loading-overlay"
        :class="{ 'show': isLoading }"
    >
      <div class="loading-spinner"></div>
    </div>
  </div>
</template>

<script>
import PublicHeader from '@/components/PublicHeader.vue'
// import PublicCarousel from "@/components/PublicCarousel.vue";
import PublicFooter from "@/components/PublicFooter.vue";

export default {
  components: {
    PublicHeader,
    // PublicCarousel,
    PublicFooter
  },
  data() {
    return {
      isLoading: true,
      isInitialLoad: true,
    }
  },
  computed: {
    isFullscreen() {
      return this.$route.meta.fullscreen === true;
    }
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      this.handleRouteChange(to, from);
    }
  },
  mounted() {
    // 页面挂载完成，移除加载状态
    this.$nextTick(() => {
      // 短暂延迟确保DOM完全渲染
      setTimeout(() => {
        this.isLoading = false;
        this.isInitialLoad = false;
      }, 50); // 很短的延迟以确保渲染完成
    });

    // 监听路由更新事件
    this.$router.afterEach(() => {
      if (!this.isInitialLoad) {
        this.isLoading = false;
      }
    });
  },
  methods: {
    handleRouteChange() {
      // 路由切换时的处理
      if (!this.isInitialLoad) {
        this.isLoading = true;

        // 在下一个tick后隐藏加载状态
        this.$nextTick(() => {
          setTimeout(() => {
            this.isLoading = false;
          }, 100);
        });
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;

  .fullscreen-layout,
  .normal-layout {
    opacity: 1;
    transition: opacity 0.15s ease-in-out;
  }
}

// 加载覆盖层
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;

  &.show {
    opacity: 1;
    visibility: visible;
  }
}

// 简单的加载动画
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
}

/* 整个滚动条 */
::-webkit-scrollbar {
  width: 10px;  /* 滚动条的宽度 */
  height: 10px; /* 滚动条的高度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  background: #F7F8FA; /* 轨道颜色 */
}

/* 滚动条上的滑块 */
::-webkit-scrollbar-thumb {
  background: #888; /* 滑块颜色 */
  border-radius: 10px; /* 滑块圆角 */
}

/* 滑块在鼠标悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #666; /* 滑块悬停颜色 */
}
</style>
